module.exports = __webpack_public_path__ + "img/shuomingPic.2c2beddf.png";